import { useQuery } from '@tanstack/react-query';
import { suppliersApi } from '../services/api';

/**
 * Liste complète des fournisseurs. Volontairement non paginée côté frontend :
 * pour matching local par SIRET/TVA/nom, on a besoin de tout. Si le volume
 * grossit (>500), on basculera sur un endpoint serveur dédié.
 */
export function useSuppliers() {
  return useQuery({
    queryKey: ['suppliers', 'all'],
    queryFn: () => suppliersApi.list({ limit: 500 }),
    staleTime: 5 * 60_000,
  });
}
